import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  orderedColumns: [
    { Header: "#", isHidden: false },
    { Header: "DEVICE", isHidden: false },
    { Header: "MILK", isHidden: false },
    { Header: "FAT", isHidden: false },
    { Header: "SNF", isHidden: false },
    { Header: "DEN", isHidden: false },
    { Header: "PRO", isHidden: false },
    { Header: "LAC", isHidden: false },
    { Header: "SOL", isHidden: false },
    { Header: "TS", isHidden: false },
    { Header: "WATER", isHidden: false },
    { Header: "FRPOINT", isHidden: false },
    { Header: "TEMP", isHidden: false },
    { Header: "PH", isHidden: false },
    { Header: "COND", isHidden: false },
    { Header: "NAME", isHidden: false },
    { Header: "QTY", isHidden: false },
    { Header: "RATE", isHidden: false },
    { Header: "AMOUNT", isHidden: false },
    { Header: "PLACE", isHidden: false },
    { Header: "DATE", isHidden: false },
    { Header: "TIME", isHidden: false },
    { Header: "N", isHidden: false },
  ],
  somaticOrderedColumns: [
    { Header: "#", isHidden: false },
    { Header: "Date", isHidden: false },
    { Header: "Time", isHidden: false },
    { Header: "ID", isHidden: false },
    { Header: "Name", isHidden: false },
    { Header: "Device", isHidden: false },
    { Header: "Milk", isHidden: false },
    { Header: "Sample", isHidden: false },
    { Header: "Cells per ml", isHidden: false },
    { Header: "Avg Size um", isHidden: false },
  ],
  testInfoOrderedColumns: [
    { Header: "#", isHidden: false },
    { Header: "Date", isHidden: false },
    { Header: "Time", isHidden: false },
    { Header: "Device", isHidden: false },
    { Header: "Name", isHidden: false },
    { Header: "Value", isHidden: false },
    { Header: "Unit", isHidden: false },
    { Header: "Status", isHidden: false },
  ],
  startDate: null,
  endDate: null,
};

const tableSlice = createSlice({
  name: "table",
  initialState,
  reducers: {
    setOrderedColumns: (state, action) => {
      return {
        ...state,
        orderedColumns: action.payload,
      };
    },
    setSomaticOrderedColumns: (state, action) => {
      return {
        ...state,
        somaticOrderedColumns: action.payload,
      };
    },
    setTestInfoOrderedColumns: (state, action) => {
      return {
        ...state,
        testInfoOrderedColumns: action.payload,
      };
    },
    setDateRange: (state, action) => {
      const { startDate, endDate } = action.payload;
      state.startDate = startDate;
      state.endDate = endDate;
    },
    resetState: () => initialState,
  },
});

export const tableSelector = (state) => state.table;
export const {
  resetState,
  setOrderedColumns,
  setSomaticOrderedColumns,
  setTestInfoOrderedColumns,
  setDateRange,
} = tableSlice.actions;
export default tableSlice.reducer;
